import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import PhdesignDashboard from '../PhdesignDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PhdesignPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < PhdesignDashboard />
    )

}